module.exports = __webpack_public_path__ + "img/基本信息.52f9603e.png";